import {
    Dialog,
    DialogActions,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead
} from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import React, {useEffect} from "react";
import {shedAction, ShedAudit} from "../../../reducers/Shed/ShedReducer";
import {useAppDispatch, useAppSelector} from "../../../reducers/hooks";
import Paper from "@mui/material/Paper";
import TableRow from "@mui/material/TableRow";
import {FormattedMessage} from "react-intl";

interface ViewShedModalProps {
    open: boolean;
    onClose: () => void;
    shedData: string | undefined;
}

export default function ViewShedModal({
                                          open,
                                          onClose,
                                          shedData,
                                      }: ViewShedModalProps) {
    const dispatch = useAppDispatch();
    const shedAudits = useAppSelector((state) => state.shedElement.currentShedAudit);
    const loading = useAppSelector((state) => state.shedElement.loading);
    const error = useAppSelector((state) => state.shedElement.error);

    useEffect(() => {
        if (shedData) {
            dispatch(shedAction(shedData));
        }
    }, [shedData]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>
                <Typography variant="h6"><FormattedMessage id="Action Shed" defaultMessage="Action Shed" /></Typography>
            </DialogTitle>
            <DialogContent>
                {loading ? (
                    <Typography variant="body1">Loading...</Typography>
                ) : error ? (
                    <Typography variant="body1" color="error">
                        {error}
                    </Typography>
                ) : (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell><Typography variant="subtitle1">c</Typography></TableCell>
                                    <TableCell><Typography variant="subtitle1"><FormattedMessage id="Old Value" defaultMessage="Old Value" /></Typography></TableCell>
                                    <TableCell><Typography variant="subtitle1"><FormattedMessage id="New Value" defaultMessage="New Value" /></Typography></TableCell>
                                    <TableCell><Typography variant="subtitle1"><FormattedMessage id="Timestamp" defaultMessage="Timestamp" /></Typography></TableCell>
                                    <TableCell><Typography variant="subtitle1">Username</Typography></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {shedAudits.map((audit: ShedAudit, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>{audit.action}</TableCell>
                                        <TableCell>
                                            {typeof audit.oldValue === "object"
                                                ? JSON.stringify(audit.oldValue, null, 2)
                                                : audit.oldValue}
                                        </TableCell>
                                        <TableCell>
                                            {typeof audit.newValue === "object"
                                                ? JSON.stringify(audit.newValue, null, 2)
                                                : audit.newValue}
                                        </TableCell>
                                        <TableCell>
                                            {audit.timestamp
                                                ? new Date(audit.timestamp as unknown as string).toLocaleString()
                                                : "N/A"}
                                        </TableCell>
                                        <TableCell>{audit.username}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    <FormattedMessage id="Close" defaultMessage="Close" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}